export let botLanguages = {
	languages: [],
};

export const setter = (props) => {
	botLanguages = {
		...botLanguages,
		...props,
	};
};
